import { Box, Container, Divider, Grid, Group, Stack, Text, Title } from "@mantine/core";
import moment from "moment";
import React, { useEffect, useState } from "react";

const DocumentPrintCustomer = ({ data = {}, dealership }, ref) => {
  const [dealershipDetails, setDealershipDetails] = useState({
    dealershipName: "Carzlane Inc",
    dealershipAddress: "2747 Annapolis Rd Hanover, MD 21076",
    phone: "(240) 307-3416",
    fax: "(240) 307-3416",
    email: "sales@carzlane.com",
  });

  useEffect(() => {
    if (dealership === "Rons") {
      setDealershipDetails({
        dealershipName: "Ron's Automotive",
        dealershipAddress: "4028 Hanover Pike, Manchester, MD 21102",
        phone: "(410) 239-3180",
        fax: "(410) 239-3180",
        email: "sales@ronsautomotive.com",
      });
    }
  }, [dealership]);

  const salesPerson1FrontGross = data?.commissions?.salesPerson1?.frontGross ? parseFloat(data?.commissions?.salesPerson1?.frontGross) : 0;
  const salesPerson1BackGross = data?.commissions?.salesPerson1?.backGross ? parseFloat(data?.commissions?.salesPerson1?.backGross) : 0;

  const salesPerson2FrontGross = data?.commissions?.salesPerson2?.frontGross ? parseFloat(data?.commissions?.salesPerson2?.frontGross) : 0;
  const salesPerson2BackGross = data?.commissions?.salesPerson2?.backGross ? parseFloat(data?.commissions?.salesPerson2?.backGross) : 0;

  const salesManagerFrontGross = data?.commissions?.salesManager?.frontGross ? parseFloat(data?.commissions?.salesManager?.frontGross) : 0;
  const salesManagerBackGross = data?.commissions?.salesManager?.backGross ? parseFloat(data?.commissions?.salesManager?.backGross) : 0;

  const financeManagerFrontGross = data?.commissions?.financeManager?.frontGross
    ? parseFloat(data?.commissions?.financeManager?.frontGross)
    : 0;
  const financeManagerBackGross = data?.commissions?.financeManager?.backGross
    ? parseFloat(data?.commissions?.financeManager?.backGross)
    : 0;

  const totalOfPayments = data?.monthlyPayment ? parseFloat(data?.monthlyPayment) * parseFloat(data?.term) : 0;

  const stockNumber = data?.stockNumber ? data.VIN.slice(-6) : "";

  return (
    <Box
      style={{
        display: "none",
      }}
    >
      <Container
        size={1980}
        pos="relative"
        ref={ref}
        style={{
          ["@page "]: {
            size: "A4",
          },
        }}
      >
        <Title order={5} transform="uppercase">
          Deal Summary
        </Title>
        <Divider size={"md"} mb={"md"} />
        <Title order={5}>{dealershipDetails.dealershipName}</Title>
        <Text size="sm">{dealershipDetails.dealershipAddress}</Text>
        <Group spacing={50}>
          <Text size="sm">Phone: {dealershipDetails.phone}</Text>
          <Text size="sm">Fax: {dealershipDetails.fax}</Text>
          <Text size="sm">Email: {dealershipDetails.email}</Text>
        </Group>
        <Grid mt={"sm"}>
          {(data.fullName || data.firstName || data.middleName || data.lastName || data.buyerAddress || data.phoneNumber) && (
            <Grid.Col span={6}>
              <Title order={5}>Buyer Information</Title>
              <Divider size={"md"} />
              <Stack spacing={"sm"}>
                {(data.fullName || data.firstName || data.middleName || data.lastName) && (
                  <Text size="sm">
                    {(data.fullName || data.firstName + " " + (data?.middleName || "") + " " + data.lastName || "N/A").trim()}
                  </Text>
                )}
                {data.email && <Text size="sm">{data.email}</Text>}
                {data.cellPhone && <Text size="sm">{data.cellPhone}</Text>}
              </Stack>
            </Grid.Col>
          )}
          <Grid.Col span={6}>
            <Title order={5}>Vehicle Information</Title>
            <Divider size={"md"} />
            <Grid gutter={"xs"}>
              <Grid.Col span={12}>
                <Text size="sm">{data.vehicleTitle}</Text>
              </Grid.Col>
              <Grid.Col span={6}>
                <Text size="sm">VIN</Text>
              </Grid.Col>
              <Grid.Col span={6}>
                <Text size="sm">{data.VIN || "N/A"}</Text>
              </Grid.Col>
              <Grid.Col span={6}>
                <Text size="sm">Stock Number</Text>
              </Grid.Col>
              <Grid.Col span={6}>
                <Text size="sm">{stockNumber || "N/A"}</Text>
              </Grid.Col>
              <Grid.Col span={6}>
                <Text size="sm">Mileage</Text>
              </Grid.Col>
              <Grid.Col span={6}>
                <Text size="sm">{data.mileage ? data.mileage + "miles" : "N/A"} </Text>
              </Grid.Col>
              <Grid.Col span={6}>
                <Text size="sm">Days in Stock</Text>
              </Grid.Col>
              <Grid.Col span={6}>
                <Text size="sm">{data.daysInStock ? data.daysInStock + " days" : "N/A"}</Text>
              </Grid.Col>
            </Grid>
          </Grid.Col>

          <Grid.Col span={6}>
            <Title order={5}>Deal Structure</Title>
            <Divider size={"md"} />
            <Grid gutter={"xs"}>
              <Grid.Col span={6}>
                <Text size="sm">Vehicle Retail Price</Text>
              </Grid.Col>
              <Grid.Col span={6}>
                <Text size="sm">${data.vehicleRetailPrice || 0}</Text>
              </Grid.Col>
              <Grid.Col span={6}>
                <Text size="sm">- Cash Down</Text>
              </Grid.Col>
              <Grid.Col span={6}>
                <Text size="sm">${data.cashDown || 0}</Text>
              </Grid.Col>
              <Grid.Col span={6}>
                <Text size="sm">- Trade Allowance</Text>
              </Grid.Col>
              <Grid.Col span={6}>
                <Text size="sm">${data.tradeIn || 0}</Text>
              </Grid.Col>
              {/* <Grid.Col span={6}>
              <Text size="sm">- Trade 2 Allowance</Text>
            </Grid.Col>
            <Grid.Col span={6}>
              <Text size="sm">${data.trade2Allowance || 0}</Text>
            </Grid.Col> */}
              <Grid.Col span={6}>
                <Text size="sm">+ Total Tax</Text>
              </Grid.Col>
              <Grid.Col span={6}>
                <Text size="sm">${data.totalTax || 0}</Text>
              </Grid.Col>
              <Grid.Col span={6}>
                <Text size="sm">+ Total Fees</Text>
              </Grid.Col>
              <Grid.Col span={6}>
                <Text size="sm">${data.fees || 0}</Text>
              </Grid.Col>
              <Grid.Col span={6}>
                <Text size="sm">+ Trade Payoff</Text>
              </Grid.Col>
              <Grid.Col span={6}>
                <Text size="sm">${data.tradeInPayOff || 0}</Text>
              </Grid.Col>
              {/* <Grid.Col span={6}>
              <Text size="sm">+ Trade 2 Payoff</Text>
            </Grid.Col>
            <Grid.Col span={6}>
              <Text size="sm">${data.trade2Payoff || 0}</Text>
            </Grid.Col> */}
              <Grid.Col span={6}>
                <Text size="sm">Term</Text>
              </Grid.Col>
              <Grid.Col span={6}>
                <Text size="sm">{data.term || 0} Months</Text>
              </Grid.Col>
              <Grid.Col span={6}>
                <Text size="sm">Days to 1st Pmt.</Text>
              </Grid.Col>
              <Grid.Col span={6}>
                <Text size="sm">{data.firstPaymentDate ? moment(data.firstPaymentDate).diff(moment(), "days") : 0} days</Text>
              </Grid.Col>
              <Grid.Col span={6}>
                <Text size="sm">APR</Text>
              </Grid.Col>
              <Grid.Col span={6}>
                <Text size="sm">{data.APR || 0}%</Text>
              </Grid.Col>
            </Grid>
          </Grid.Col>
          <Grid.Col span={6}>
            <Grid>
              <Grid.Col span={6}>
                <Title order={5}>Deal Information</Title>
              </Grid.Col>
              <Grid.Col span={6}>
                <Title order={5}>Deal Type: Finance</Title>
              </Grid.Col>
            </Grid>
            <Divider size={"md"} />
            <Grid gutter={"xs"}>
              <Grid.Col span={6}>
                <Text size="sm">Deal Number</Text>
              </Grid.Col>
              <Grid.Col span={6}>
                <Text size="sm">{data.dealNumber}</Text>
              </Grid.Col>
              <Grid.Col span={6}>
                <Text size="sm">Deal Date</Text>
              </Grid.Col>
              <Grid.Col span={6}>
                <Text size="sm">{data.dealDate || moment().format("MM/DD/YYYY")}</Text>
              </Grid.Col>
              <Grid.Col span={6}>
                <Text size="sm">ROS Number</Text>
              </Grid.Col>
              <Grid.Col span={6}>
                <Text size="sm">{data.rosNumber}</Text>
              </Grid.Col>
              <Grid.Col span={6}>
                <Text size="sm">Service Contract</Text>
              </Grid.Col>
              <Grid.Col span={6}>
                <Text size="sm">${data.protectionPlanPrice || 0}</Text>
              </Grid.Col>
              <Grid.Col span={6}>
                <Text size="sm">Additional Products</Text>
              </Grid.Col>
              <Grid.Col span={6}>
                <Text size="sm">${data.additionalProducts || 0}</Text>
              </Grid.Col>
              <Grid.Col span={6}>
                <Text size="sm">Insurance</Text>
              </Grid.Col>
              <Grid.Col span={6}>
                <Text size="sm">${data.VSI || 0}</Text>
              </Grid.Col>
              <Grid.Col span={6}>
                <Text size="sm">GAP</Text>
              </Grid.Col>
              <Grid.Col span={6}>
                <Text size="sm">${data.GAP || 0}</Text>
              </Grid.Col>
              <Grid.Col span={6}>
                <Text size="sm">Theft</Text>
              </Grid.Col>
              <Grid.Col span={6}>
                <Text size="sm">${data.theft || 0}</Text>
              </Grid.Col>
              <Grid.Col span={6}>
                <Text size="sm">Accessories</Text>
              </Grid.Col>
              <Grid.Col span={6}>
                <Text size="sm">${data.accessoriesPrice || 0}</Text>
              </Grid.Col>
              <Grid.Col span={6}>
                <Text size="sm">Surface Protection</Text>
              </Grid.Col>
              <Grid.Col span={6}>
                <Text size="sm">${data.surfaceProtection || 0}</Text>
              </Grid.Col>
              <Grid.Col span={6}>
                <Text size="sm">Backend</Text>
              </Grid.Col>
              <Grid.Col span={6}>
                <Text size="sm">${data.backend || 0}</Text>
              </Grid.Col>
              <Grid.Col span={6}>
                <Text size="sm">Deal Cost</Text>
              </Grid.Col>
              <Grid.Col span={6}>
                <Text size="sm">${data.dealCost || 0}</Text>
              </Grid.Col>
              <Grid.Col span={6}>
                <Text size="sm">Vehicle Cost Price</Text>
              </Grid.Col>
              <Grid.Col span={6}>
                <Text size="sm">${data.vehicleCostPrice || 0}</Text>
              </Grid.Col>
              <Grid.Col span={6}>
                <Text size="sm">Flooring Cost</Text>
              </Grid.Col>
              <Grid.Col span={6}>
                <Text size="sm">${data.flooringCost || 0}</Text>
              </Grid.Col>
            </Grid>
          </Grid.Col>

          <Grid.Col span={12} mt={"sm"}>
            <Title order={5}>Results</Title>
            <Divider size={"md"} />
            <Grid>
              <Grid.Col span={6}>
                <Grid gutter={"xs"}>
                  <Grid.Col span={6}>
                    <Text size="sm">Payment</Text>
                  </Grid.Col>
                  <Grid.Col span={6}>
                    <Text size="sm">${data.monthlyPayment || 0}</Text>
                  </Grid.Col>
                  <Grid.Col span={6}>
                    <Text size="sm">Amount Financed</Text>
                  </Grid.Col>
                  <Grid.Col span={6}>
                    <Text size="sm">${data.amountFinanced || 0}</Text>
                  </Grid.Col>
                  <Grid.Col span={6}>
                    <Text size="sm">Finance Charges</Text>
                  </Grid.Col>
                  <Grid.Col span={6}>
                    <Text size="sm">${data.financeCharges || 0}</Text>
                  </Grid.Col>
                  <Grid.Col span={6}>
                    <Text size="sm">Total Payments</Text>
                  </Grid.Col>
                  <Grid.Col span={6}>
                    <Text size="sm">${totalOfPayments || 0}</Text>
                  </Grid.Col>
                </Grid>
              </Grid.Col>
            </Grid>
          </Grid.Col>
        </Grid>
      </Container>
    </Box>
  );
};

export default React.forwardRef(DocumentPrintCustomer);
